<template>
  <div>
    <section class="hero is-primary">
      <div class="container">
        <nav
          class="breadcrumb is-small"
          aria-label="breadcrumbs"
        >
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'playlists' }">
                Playlists
              </router-link>
            </li>
            <li class="is-active">
              <a
                href="#"
                aria-current="page"
              >{{ "New" }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="title">
          <h1>New song for {{ playlist.name }}</h1>
        </div>
        <playlist-item-edit />
      </div>
    </section>
    <a
      class="add button is-large is-warning"
      @click="save()"
    >
      <span class="icon is-medium">
        <i class="fas fa-check" />
      </span>
    </a>
  </div>
</template>

<script>
import PlaylistItemEdit from "../components/PlaylistItemEdit";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PlaylistItemEdit
  },
  computed: {
    ...mapGetters({ playlist: "selectedPlaylist" })
  },
  mounted() {
    this.fetchPlaylist(this.$route.params.playlistId);
  },
  methods: {
    save() {
      this.$store.dispatch("createPlaylistItem").then(() => {
        this.$router.push({
          name: "playlist",
          params: { playlistId: this.$route.params.playlistId },
          query: { edit: "true" }
        });
      });
    },
    ...mapActions(["fetchPlaylist"])
  }
};
</script>

<style lang="scss">
.save {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// NewPlaylistItem.vue?1eaf11b2